import type React from "react";
import {
  IconHistory,
  IconApi,
  IconUser,
  IconCurrencyDollar,
  type TablerIconsProps,
} from "@tabler/icons-react";

// Lazy load views
import CompletedTransactions from "views/completedTransactions";
import TransactionHistory from "views/transactionHistory";
import RateSettings from "views/rateSettings";
import APIs from "views/Apis";
import UsersManagement from "views/usersManagement";
import AdminAccess from "views/adminAccess";
import ChangePassword from "views/changePassword";
import Login from "views/login";
import Logout from "views/logout";

// Types
export interface RouteConfig {
  path: string;
  Component: React.ComponentType;
  isPrivate: boolean;
  label?: string;
  Icon?: React.ComponentType<TablerIconsProps>;
  showInNav?: boolean;
  section?: "dashboard" | "settings";
  requireSuperAdmin?: boolean;
  requireAdmin?: boolean;
}

// Centralized Navigation & Routes Configuration
export const APP_ROUTES: RouteConfig[] = [
  // Dashboard Routes
  {
    path: "/users",
    Component: UsersManagement,
    isPrivate: true,
    label: "Users",
    Icon: IconUser,
    showInNav: true,
    section: "dashboard",
  },
  {
    path: "/transaction-history",
    Component: TransactionHistory,
    isPrivate: true,
    label: "Transaction History",
    Icon: IconHistory,
    showInNav: true,
    section: "dashboard",
  },
  {
    path: "/completed-transactions",
    Component: CompletedTransactions,
    isPrivate: true,
    showInNav: false,
  },

  {
    path: "/apis",
    Component: APIs,
    isPrivate: true,
    label: "APIs",
    Icon: IconApi,
    showInNav: true,
    section: "dashboard",
  },

  {
    path: "/earning-fee",
    Component: RateSettings,
    isPrivate: true,
    label: "Earning Fee",
    Icon: IconCurrencyDollar,
    showInNav: true,
    section: "dashboard",
  },

  // Settings Routes

  {
    path: "/admin-management",
    Component: AdminAccess,
    isPrivate: true,
    label: "Admin Management",
    showInNav: true,
    section: "settings",
    requireSuperAdmin: true,
  },
  {
    path: "/change-password",
    Component: ChangePassword,
    isPrivate: true,
    label: "Change password",
    showInNav: true,
    section: "settings",
    requireAdmin: true,
  },

  // Auth Routes (not shown in navigation)
  {
    path: "/login",
    Component: Login,
    isPrivate: false,
    showInNav: false,
  },
  {
    path: "/logout",
    Component: Logout,
    isPrivate: false,
    showInNav: false,
  },
];

// Helper functions to filter routes
export const getDashboardNavItems = () =>
  APP_ROUTES.filter((route) => route.showInNav && route.section === "dashboard");

export const getSettingsNavItems = (profile?: { isSuperAdmin?: boolean; isAdmin?: boolean }) =>
  APP_ROUTES.filter(
    (route) =>
      route.showInNav &&
      route.section === "settings" &&
      (!route.requireSuperAdmin || profile?.isSuperAdmin) &&
      (!route.requireAdmin || profile?.isAdmin)
  );

export const getAllRoutes = () => APP_ROUTES;

